import { IInvestigator } from '@app/core/state/entities/investigator/investigator.entity';
import { defaultEntityState } from '@app/core/state/entities/entity';
import {
  mergeEntityState,
  normalizeAndMergeEntity,
} from '@app/core/state/entities/entity.helpers';
import { authApiActions } from '@app/core/auth/auth.actions';
import { profileUpdatedDtoSchema } from '@core/auth/auth.effects';
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const investigatorEntityReducer = createReducer(
  defaultEntityState<IInvestigator>(),
  on(
    authApiActions.addNewEmailVerificationEmailSent,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.requestToJoinProjectResponseReceived,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.requestToJoinProjectCancelled,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.invitationResponseReceived,
    projectDetailActions.projectListingsLoaded,
    authApiActions.signInRecorded,
    (state, props) => mergeEntityState(entityKey.investigators, state, props)
  ),
  on(
    authApiActions.profilePictureUpdated,
    authApiActions.profileEmailVerifiedAndAdded,
    authApiActions.profileNameUpdated,
    authApiActions.emailRemovedFromProfile,
    (state, props) =>
      normalizeAndMergeEntity(
        entityKey.investigators,
        state,
        props,
        profileUpdatedDtoSchema
      )
  )
);
